import React from 'react';
import styled from 'styled-components';
import * as types from '../../actions/actionTypes';

import Text from '../common/Text';
import Translatable from '../common/Translatable';
import Link from '../InternalLink';

const SelectedValuesPane = ({ sewpatId, previousLocation }) => {
    const StyledSelectedValuesPane = styled.div`
        display: grid;
        grid-template-columns: repeat(3,minmax(7em, 10em));
        grid-column-gap: 1em;
        font-size: 0.81em;
        line-height: 1.1;

        & .schnoffle-selection-label {
          grid-row: 1 / span 2;
        }
        & .schnoffle-selection-edit {
          grid-row: 2;
        }
        & .schnoffle-capitalize {
          text-transform: capitalize;
        }

    `;

    const getChangePatternLink = () => {
        if (previousLocation) {
            return (
                <React.Fragment>
                    <div className='schnoffle-capitalize'>
                        <Translatable
                            message='CHANGE_PATTERN_SELECTION'
                        />
                    </div>
                    <div className='schnoffle-selection-edit'>
                        <Link
                            to={previousLocation}
                        >
                            <Translatable message='CHANGE_SELECTION_LABEL' />
                        </Link>
                    </div>
                </React.Fragment>
            );
        }
        return null;
    };

    return (
        <Text colored margin='0.5rem 0'>
            <StyledSelectedValuesPane>
                <div className='schnoffle-selection-label'><Translatable
                    message='SELECTED_VALUES_LABEL'
                /></div>
                <div className='schnoffle-capitalize'><Translatable
                    message='SEWPAT_SHORT'
                />: {sewpatId}</div>
                <div className='schnoffle-selection-edit'>
                    <Link
                        to={{
                            type: types.NAVIGATED_TO_SEWPAT_GALLERY,
                        }}
                    >
                        <Translatable message='CHANGE_SELECTION_LABEL' />
                    </Link>
                </div>
                {getChangePatternLink()}
            </StyledSelectedValuesPane>
        </Text>
    );
};

export default SelectedValuesPane;



// WEBPACK FOOTER //
// ./src/components/common/SelectedValuesPane.js